export default "__VITE_ASSET__xeTeJkZ8__"